import { useState } from "react";
import "./SignUpPage.css";
import {
  IoPersonOutline,
  IoMailOutline,
  IoLockClosedOutline,
  IoPhonePortraitOutline,
  IoEyeOutline,
  IoEyeOffOutline,
  IoMale,
  IoFemale,
  IoCalendarOutline,
  IoTimeOutline,
  IoResizeOutline,
  IoArrowForward,
} from "react-icons/io5";
import { useLoginContext } from "../../context/Login_context";
import Notification from "../../utils/Notification";
import { Oval } from "react-loader-spinner";
import dayjs from "dayjs";
import { IOSDatePicker, IOSTimePicker } from "../../components/Iospicker";

const SignUpPage = ({ goToLogin }) => {
  const maxAllowedDate = new Date(
    new Date().setFullYear(new Date().getFullYear() - 18),
  );
  const { RegisterUser, register_loading } = useLoginContext();

  // ── Form state
  const [name, setName] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [password, setPassword] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [timeOfBirth, setTimeOfBirth] = useState(null);
  const [height, setHeight] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // ── Picker open/close
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showTimePicker, setShowTimePicker] = useState(false);

  const email_validation =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
  const phone_validation = /^[0-9]{10}$/;

  const handleSignUp = (e) => {
    e.preventDefault();
    if (!name) return Notification("warning", "Name is Required!");
    if (!gender) return Notification("warning", "Gender is Required!");
    if (!number) return Notification("warning", "Phone Number is Required!");
    if (!phone_validation.test(number))
      return Notification("warning", "Enter a valid 10-digit Phone Number!");
    if (!email) return Notification("warning", "Email ID is Required!");
    if (!email_validation.test(email))
      return Notification("warning", "Enter Valid Email ID!");
    if (!password) return Notification("warning", "Password is Required!");

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email.toLowerCase().trim());
    formData.append("number", number);
    formData.append("password", password);
    formData.append("gender", gender);
    formData.append(
      "dob",
      dateOfBirth ? dayjs(dateOfBirth).format("YYYY-MM-DD") : "",
    );

    formData.append(
      "time_of_birth",
      timeOfBirth ? dayjs(timeOfBirth).format("HH:mm") : "",
    );
    formData.append("height", height);
    RegisterUser(formData, goToLogin);
  };

  const handlePhoneChange = (e) => {
    const val = e.target.value;
    if (val === "" || /^[0-9]*$/.test(val)) setNumber(val);
  };

  return (
    <div className="container">
      <div className="signup-card">
        <div className="header">
          <div className="logo-container">J</div>
          <h1>Create Account</h1>
          <p>Sign up to get started</p>
        </div>

        <form onSubmit={handleSignUp}>
          {/* Full Name */}
          <div className="input-wrapper">
            <label className="label">
              Full Name <span className="required">*</span>
            </label>
            <div className="input-container">
              <IoPersonOutline className="input-icon" />
              <input
                type="text"
                className="input-field"
                placeholder="Enter name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>

          {/* Gender */}
          <div className="input-wrapper">
            <label className="label">
              Gender <span className="required">*</span>
            </label>
            <div className="gender-container">
              <button
                type="button"
                className={`gender-button ${gender === "Male" ? "active" : ""}`}
                onClick={() => setGender("Male")}
              >
                <IoMale /> Male
              </button>
              <button
                type="button"
                className={`gender-button ${gender === "Female" ? "active" : ""}`}
                onClick={() => setGender("Female")}
              >
                <IoFemale /> Female
              </button>
            </div>
          </div>

          {/* Number */}
          <div className="input-wrapper">
            <label className="label">
              Number <span className="required">*</span>
            </label>
            <div className="input-container">
              <IoPhonePortraitOutline className="input-icon" size={20} />
              <input
                type="text"
                className="input-field"
                placeholder="Enter 10 digit number"
                value={number}
                maxLength={10}
                onChange={handlePhoneChange}
              />
            </div>
          </div>

          {/* Email */}
          <div className="input-wrapper">
            <label className="label">
              Email Address <span className="required">*</span>
            </label>
            <div className="input-container">
              <IoMailOutline className="input-icon" />
              <input
                type="email"
                className="input-field"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          {/* Password */}
          <div className="input-wrapper">
            <label className="label">
              Password <span className="required">*</span>
            </label>
            <div className="input-container">
              <IoLockClosedOutline className="input-icon" />
              <input
                type={showPassword ? "text" : "password"}
                className="input-field"
                placeholder="Create password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div
                className="eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <IoEyeOutline size={20} />
                ) : (
                  <IoEyeOffOutline size={20} />
                )}
              </div>
            </div>
          </div>

          {/* Date + Time Row */}
          <div className="row">
            <div className="input-wrapper">
              <label className="label">Date of Birth</label>
              <div
                className="input-container picker-trigger"
                onClick={() => setShowDatePicker(true)}
                onFocus={(e) => e.target.blur()}
              >
                <IoCalendarOutline
                  className="input-icon"
                  size={18}
                  style={{ color: "#667eea" }}
                />
                <input
                  type="text"
                  className="input-field"
                  placeholder="Select date"
                  value={
                    dateOfBirth ? dayjs(dateOfBirth).format("YYYY-MM-DD") : ""
                  }
                />
              </div>
            </div>

            <div className="input-wrapper">
              <label className="label">Time of Birth</label>
              <div
                className="input-container picker-trigger"
                onClick={() => setShowTimePicker(true)}
                onFocus={(e) => e.target.blur()}
              >
                <IoTimeOutline
                  className="input-icon"
                  size={18}
                  style={{ color: "#667eea" }}
                />
                <input
                  type="text"
                  className="input-field"
                  placeholder="Select time"
                  value={timeOfBirth ? dayjs(timeOfBirth).format("HH:mm") : ""}
                />
              </div>
            </div>
          </div>

          {/* Height */}
          <div className="input-wrapper">
            <label className="label">Height</label>
            <div className="input-container">
              <IoResizeOutline className="input-icon" size={18} />
              <input
                type="text"
                className="input-field"
                placeholder="e.g. 5'8 foot"
                value={height}
                onChange={(e) => setHeight(e.target.value)}
              />
            </div>
          </div>

          <button
            type="submit"
            className="signup-btn"
            disabled={register_loading}
          >
            {register_loading ? (
              <Oval
                height={40}
                width={40}
                color="#F5F5F5"
                visible
                ariaLabel="oval-loading"
                secondaryColor="#F5F5F5"
                strokeWidth={2}
                strokeWidthSecondary={2}
              />
            ) : (
              "Sign Up"
            )}
            {!register_loading && <IoArrowForward />}
          </button>

          <div className="divider">
            <div className="line" />
            <div className="divider-text">OR</div>
            <div className="line" />
          </div>

          <div className="login-footer">
            Already have an account?
            <span className="login-link" onClick={goToLogin}>
              Login
            </span>
          </div>
        </form>
      </div>
      {showDatePicker && (
        <IOSDatePicker
          value={dateOfBirth}
          maxDate={maxAllowedDate}
          onChange={(d) => setDateOfBirth(d)}
          onClose={() => setShowDatePicker(false)}
        />
      )}

      {showTimePicker && (
        <IOSTimePicker
          value={timeOfBirth}
          onChange={(t) => setTimeOfBirth(t)}
          onClose={() => setShowTimePicker(false)}
        />
      )}
    </div>
  );
};

export default SignUpPage;
